import { api } from '@/shared/services/api';

import {
  CreateOrderMemoRequest,
  CreateOrderMemoResponse,
  UpdateOrderAmountRequest,
  UpdateOrderMemoRequest,
  UpdateOrderMemoResponse,
  UpdateOrderStatusRequest,
} from '../types/orderTypes';

export const orderService = {
  // 주문 금액 수정
  updateOrderAmount: (orderUuid: string, data: UpdateOrderAmountRequest) =>
    api.patch<string>(`/api/v1/order/amount/${orderUuid}`, data),

  // 주문 메모 등록
  createOrderMemo: (orderUuid: string, data: CreateOrderMemoRequest) =>
    api.post<CreateOrderMemoResponse>(`/api/v1/order/memo/${orderUuid}`, data),

  // 주문 메모 수정
  updateOrderMemo: (orderMemoUuid: string, data: UpdateOrderMemoRequest) =>
    api.patch<UpdateOrderMemoResponse>(
      `/api/v1/order/memo/${orderMemoUuid}`,
      data,
    ),

  // 주문 메모 삭제
  deleteOrderMemo: (orderMemoUuid: string) =>
    api.delete<string>(`/api/v1/order/memo/${orderMemoUuid}`),

  // 주문 상태 변경
  updateOrderStatus: (orderUuid: string, data: UpdateOrderStatusRequest) =>
    api.patch<string>(`/api/v1/order/status/${orderUuid}`, data),
};
